var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivateBlogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.14466,
    y: 2.80646,
    width: 18.0323,
    height: 21.3871,
    rx: 1.04839,
    stroke: "#4A4A4A",
    strokeWidth: 1.25806
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71094 6.37097H18.0335M6.71094 9.72581H18.0335M6.71094 13.0806H18.0335M6.71094 16.4355H13.84",
    stroke: "#4A4A4A",
    strokeWidth: 1.25806,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9336 18.9516C15.9336 16.6356 17.8111 14.7581 20.1271 14.7581H20.9658C23.2819 14.7581 25.1594 16.6356 25.1594 18.9516V23.1452H15.9336V18.9516Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7734 18.9516L18.8702 21.0484L23.4831 16.4355",
    stroke: "#4A4A4A",
    strokeWidth: 1.25806,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateBlogIcon);
export default __webpack_public_path__ + "static/media/activate-blog-icon.cba0da258a405ef62293e1077893db1e.svg";
export { ForwardRef as ReactComponent };